import { mapState } from 'vuex';

export default {
  name: 'MenuHeader',
  computed: {
    ...mapState({
      authUser: state => state.authUser,
      isActive2fa: state => state.isActive2fa
    })
  }
};
